import { Helmet } from 'react-helmet-async';

import { Breadcrumbs } from '../../components/Breadcrumbs';
import { Loading } from '../../components/Loading';

import { useMissionContext } from '../../contexts/MissionContext/hooks/useMissionContext.hook';
import { MissionContextStatus } from '../../contexts/MissionContext/types/mission-context.type';
import { useMissionBreadcrumbPaths } from '../../hooks/useMissionBreadcrumbPaths.hook';
import { useMissionSpaceWording } from '../../hooks/useMissionSpaceWording.hook';
import { buildDocumentTitle } from '../../utils/document-title.util';
import { PageTitle } from '../../components/PageTitle';

import { MissionTabs } from './Tabs';

export const MissionPage = () => {
  const missionContext = useMissionContext();
  const missionWording = useMissionSpaceWording();
  const missionBreadcrumbPaths = useMissionBreadcrumbPaths();

  const beforeTitleContent = (
    <>
      <Helmet>
        <title>
          {buildDocumentTitle(
            `Fiche ${missionWording.name}`,
            missionContext.mission?.code,
          )}
        </title>
      </Helmet>
      <Breadcrumbs paths={[...missionBreadcrumbPaths]} />
    </>
  );

  const titleContent = <PageTitle title={`Fiche ${missionWording.name}`} />;

  if (missionContext.status !== MissionContextStatus.Ready) {
    return (
      <>
        <Loading />
        {beforeTitleContent}
        {titleContent}
      </>
    );
  }

  const { mission } = missionContext;

  return (
    <>
      {beforeTitleContent}
      <PageTitle code={mission.code} title={mission.consolidation.title} />
      <MissionTabs />
    </>
  );
};
